import { inject, Injectable, signal } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { jwtDecode } from 'jwt-decode';
import { Auth } from '../models/auth.model';
import { HttpClient } from '@angular/common/http';
import { LoginModel } from '../../pages/login/models/login.model';
import { Observable } from 'rxjs';
import { LoginResponse } from '../models/app.model';
import { getFullUrl } from '../utils/utils';
import { endpoint } from '../../../enviroment/endpoint';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  accessTokenKey = 'access_token';
  refreshTokenKey = 'refresh_token';

  cookieService = inject(CookieService);
  http = inject(HttpClient);
  router = inject(Router);

  private _isAuthenticated = signal<boolean>(!!this.cookieService.get(this.accessTokenKey));
  readonly isAuth = this._isAuthenticated.asReadonly();

  public login(payload: LoginModel): Observable<{ data: LoginResponse }> {
    const url = getFullUrl(endpoint.auth.url, endpoint.auth.login);
    return this.http.post(url, payload) as Observable<{ data: LoginResponse }>;
  }

  public refreshToken(): Observable<{ data: LoginResponse }> {
    const url = getFullUrl(endpoint.auth.url, endpoint.auth.refresh);
    return this.http.post(url, {
      refreshToken: this.getRefreshToken()
    }) as Observable<{ data: LoginResponse }>;
  }

  public isAuthenticated(): boolean {
    return this._isAuthenticated();
  }

  public setToken(token: LoginResponse): void {
    this.clearAuthCookies();
    this.cookieService.set(this.accessTokenKey, token.token, undefined, '/');
    this.cookieService.set(this.refreshTokenKey, token.refreshToken, undefined, '/');
    this._isAuthenticated.set(true);
  }

  public getAccessToken(): string {
    return this.cookieService.get(this.accessTokenKey);
  }

  public getRefreshToken(): string {
    return this.cookieService.get(this.refreshTokenKey);
  }

  public getProfile(): Auth {
    return jwtDecode(this.getAccessToken()) as Auth;
  }

  public logout(): void {
    this.clearAuthCookies();
    this._isAuthenticated.set(false);
    void this.router.navigate(['/']);
  }

  private clearAuthCookies(): void {
    this.pathHierarchy().forEach(path => {
      this.cookieService.delete(this.accessTokenKey, path);
      this.cookieService.delete(this.refreshTokenKey, path);
    });
  }

  private pathHierarchy(): string[] {
    const paths = ['/'];
    const segments = window.location.pathname.split('/').filter(Boolean);
    let current = '';
    segments.forEach(seg => {
      current += '/' + seg;
      paths.push(current);
    });
    return paths;
  }
}
